/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { getRequest } from "utils/request"
import { CircularProgress } from "@material-ui/core"
import { putRequest } from "utils/request"

import { i18n } from "../../../../translate/i18n"
import { useModal } from "hooks/modal"
import { toast } from "react-toastify"
import { SelectStatusForRefusedChat } from "./SelectStatusForRefusedChat"
// waiting for business people to define the status for refused chat
// import { SelectStatusForRefusedChat } from "./SelectStatusForRefusedChat"

export default function TabWhatsapp({ companyData, handleGoBack }) {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({})
  const [bot, setBot] = useState(false)
  const [bots, setBots] = useState([])
  const { toggleHelperId } = useModal()

  const loadWhatsappToken = async () => {
    setLoading(true)
    getRequest(`/bots?companyId=${companyData.id}&onlyActive=1`).then(function (
      response
    ) {
      setBots(response.data)
      setLoading(false)
    })

    const ReturnGet = await getRequest(
      `/companieschannels/settings/whatsapp?CompanyId=${companyData.id}`
    )
    if (ReturnGet.success) {
      ReturnGet.data.webhook =
        ReturnGet.data.source === "Twilio"
          ? `${process.env.REACT_APP_API_URL}/whatsappcallback/${companyData.id}`
          : `${process.env.REACT_APP_API_URL}/whatsappofficialcallback/${companyData.id}`
      setData(ReturnGet.data)
      if (!!ReturnGet.data.BotId) {
        setBot(true)
      }
    }
    setLoading(false)
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setData({ ...data, [name]: value })
  }

  useEffect(() => {
    loadWhatsappToken()
  }, [companyData])

  const handleSave = () => {
    setLoading(true)

    putRequest(`/companieschannels/settings/whatsapp`, {
      CompanyId: companyData.id,
      token: data.token,
      cellPhone: data.cellPhone,
      BotId: data.BotId ? Number(data.BotId) : null,
      AccountSid: data.source === "Meta" ? null : data.AccountSid,
      source: data.source,
      statusForRefusedChat: data.statusForRefusedChat
        ? Number(data.statusForRefusedChat)
        : null,
    }).then(function () {
      setLoading(false)
      handleGoBack()
    })
  }

  const handleCopy = (data) => {
    navigator.clipboard.writeText(data)
    toast.info(i18n.t("successCopy"))
  }

  useEffect(() => {
    if (bot === false) {
      setData({ ...data, botId: "" })
    }
  }, [bot])

  useEffect(() => {
    toggleHelperId(26)
  }, [])

  return (
    <div style={{ minHeight: "30vh" }}>
      <div className="title-helper-container">
        <h3>{companyData.nickName}</h3>
      </div>
      <h3> WHATSAPP</h3>
      <div>
        {!loading ? (
          <form
            className="form-edit"
            style={{ height: "60vh" }}
            onSubmit={(e) => {
              e.preventDefault()
              handleSave()
            }}
          >
            <div className="form-group col-md-12">
              <div style={{ marginRight: 10 }}>
                <label className="col-form-label">{i18n.t("source")}:</label>
              </div>
              <select
                className="form-control"
                name="source"
                value={data.source}
                required
                onChange={handleInputChange}
              >
                <option value="Twilio">Twilio</option>
                <option value="Meta">Meta</option>
              </select>
              <div>
                {data.source === "Twilio" ? (
                  <>
                    <div style={{ marginRight: 10 }}>
                      <label className="col-form-label">Account SID:</label>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      value={data.AccountSid}
                      required
                      name="AccountSid"
                      onChange={handleInputChange}
                    />
                  </>
                ) : null}
                <div style={{ marginRight: 10 }}>
                  <label className="col-form-label">Webhook:</label>
                </div>
                <input
                  disabled
                  type="text"
                  className="form-control"
                  value={data.webhook}
                  required
                />
                <button
                  style={{ top: 120, right: 30 }}
                  type="button"
                  className="copyButton"
                  onClick={() => handleCopy(data.webhook)}
                >
                  <i className="far fa-copy" style={{ fontSize: 20 }}></i>
                </button>
                <div style={{ marginRight: 10 }}>
                  <label className="col-form-label">Token:</label>
                </div>
                <textarea
                  type="text"
                  className="form-control"
                  style={{ resize: "none" }}
                  rows="3"
                  value={data.token}
                  name="token"
                  required
                  onChange={handleInputChange}
                />

                <div style={{ marginRight: 10 }}>
                  <label className="col-form-label">
                    {i18n.t("cellphone")}:
                  </label>
                </div>
                <input
                  type="text"
                  className="form-control"
                  value={data.cellPhone}
                  name="cellPhone"
                  required
                  onChange={handleInputChange}
                />

                <div style={{ marginTop: 10 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={bot}
                      onChange={(value) => {
                        setBot(value.target.checked)
                      }}
                    />
                    <label style={{ marginLeft: 5 }} className="col-form-label">
                      {i18n.t("attendanceBot")}:
                    </label>
                  </div>
                  {bot && (
                    <div className="form-bot">
                      <select
                        className="select2 form-control select2-multiple"
                        style={{
                          width: 200,
                        }}
                        name="BotId"
                        required={bot === true}
                        value={data.BotId || ""}
                        onChange={handleInputChange}
                      >
                        {bots.length > 0 ? (
                          <>
                            <option value="">{i18n.t("chooseOne")}</option>
                            {bots.map((bot) => {
                              return (
                                <option key={bot.id} value={bot.id}>
                                  {bot.description}
                                </option>
                              )
                            })}
                          </>
                        ) : (
                          <option value="">{i18n.t("doesNotHaveBot")}</option>
                        )}
                      </select>
                    </div>
                  )}
                </div>
              </div>

              <SelectStatusForRefusedChat
                handleInputChange={handleInputChange}
                statusForRefusedChat={data.statusForRefusedChat}
              />

              <div
                className=""
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={() => handleGoBack()}
                >
                  <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                  {i18n.t("getBack")}
                </button>
                <button type="submit" className="btn btn-outline-success">
                  <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                  {i18n.t("save")}
                </button>
              </div>
            </div>
          </form>
        ) : (
          <div className="area-loading">
            <CircularProgress />
          </div>
        )}
      </div>
    </div>
  )
}
